// Общие framer-motion варианты. Один набор кривых на весь сайт, чтобы
// reveal-анимации секций совпадали по ритму.

export const EASE = [0.22, 1, 0.36, 1];

export const viewportOnce = { once: true, amount: 0.25 };

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: EASE } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.8, ease: EASE } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.94 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.7, ease: EASE } },
};

export const stagger = (staggerChildren = 0.08, delayChildren = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren, delayChildren } },
});

// Заголовок появляется словами: обёртка + элемент на каждое слово.
export const wordsContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.055, delayChildren: 0.05 } },
};

export const word = {
  hidden: { opacity: 0, y: "0.4em", filter: "blur(6px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.55, ease: EASE },
  },
};

export const revealProps = {
  initial: "hidden",
  whileInView: "show",
  viewport: viewportOnce,
};

export const hoverLift = {
  y: -6,
  transition: { duration: 0.28, ease: EASE },
};
